import React, { useContext, useState, useEffect } from "react";
import Login from "./components/login/login";
import { AuthProvider, AuthContext } from "./AuthContext";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import HomePage from "./components/home/home";
import Register from "./components/register/register";
import ResetPassword from "./components/password/resetPassword/reset-password";
import ValidateOTP from "./components/password/validateOtp/validate-otp";
import UpdatePassword from "./components/password/updatePassword/update-password";
import ValidateOTPLogin from "./components/login/validateOtpLogin/validate-otp-login";
import PasswordResetSuccess from "./components/password/passwordResetSuccess/password-reset-success";
import Dashboard from "./components/dashboard/dashboard";
import ESafetyContractAdmission from "./components/forms/admission/eSafetyContract/e-safety-contract";
import EssentialInformationSheet from "./components/forms/admission/essentialInformationSheet/essential-information-sheet";
import PropertyInventoryAdmission from "./components/forms/admission/propertyInventory/property-inventory";
import AdmissionForm from "./components/forms/admission/admissionForm/admission-form";
import AdmissionConfirmation from "./components/forms/admission/admissionConfirmation/admission-confirmation";
import RiskAssessmentAdmission from "./components/forms/admission/riskAssessment/risk-assessment";
import PersonalEmergencyAdmission from "./components/forms/admission/personalEmergency/personal-emergency";
import HouseRulesAdmission from "./components/forms/admission/houseRules/house-rules-admission";
import MobilePhoneContractAdmission from "./components/forms/admission/mobilePhoneContract/mobile-phone-contract";
import AntiBullyingAdmission from "./components/forms/admission/antiBullyingContract/anti-bullying-contract";
import OfstedInspectContractAdmission from "./components/forms/admission/ofstedInspectionContract/ofsted-inspection-contract";
import RoomSearchAgreeAdmission from "./components/forms/admission/roomSearchAgreement/room-search-agreement";
import MedicalConsentAdmission from "./components/forms/admission/medicalConsent/medical-consent";
import CypForm from "./components/forms/preAdmissionForms/childrenGuideDOC/cyp-forms";
import AccessHealthCareRecordsForm from "./components/forms/preAdmissionForms/accessHealthRecords/access-health-records";
import MatchingAssesmentForm from "./components/forms/preAdmissionForms/matchingAssessment/matching-assesment-form";
import MobileIncompatiblePage from "./common/mobileView/mobileView";

const PrivateRoute = ({ children }) => {
  const { isLoggedIn } = useContext(AuthContext);
  return isLoggedIn ? children : <Navigate to='/login' />;
};
const App = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) {
    return <MobileIncompatiblePage />;
  }

  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* login */}
          <Route path='/' element={<Navigate to='/login' />} />
          <Route path='/register' element={<Register />} />
          <Route path='/login' element={<Login />} />
          <Route path='/request-reset-password' element={<ResetPassword />} />
          <Route path='/validate-otp' element={<ValidateOTP />} />
          <Route path='/reset-password' element={<UpdatePassword />} />
          <Route path='/reset-success' element={<PasswordResetSuccess />} />

          {/* DashBoard Routes */}
          <Route path='/dashboard' element={<Dashboard />} />
          <Route path='/logout' element={<Dashboard />} />
          <Route path='/task-history' element={<Dashboard />} />
          <Route path='/manager-all-tasks' element={<Dashboard />} />
          <Route path='/manager-task-assign' element={<Dashboard />} />
          <Route path='/manager-task-create' element={<Dashboard />} />
          <Route path='/manager-task-complete' element={<Dashboard />} />
          <Route path='/manager-task-incomplete' element={<Dashboard />} />
          <Route path='/manager-task-form' element={<Dashboard />} />
          <Route path='/logs-incident' element={<Dashboard />} />
          <Route path='/daily-logs' element={<Dashboard />} />
          <Route path='/non-physical' element={<Dashboard />} />
          <Route path='/cause-concern' element={<Dashboard />} />
          <Route path='/incident-management-view' element={<Dashboard />} />
          <Route path='/safe-guarding-view' element={<Dashboard />} />
          <Route path='/cause-concern-view' element={<Dashboard />} />
          <Route path='/employee-schedule' element={<Dashboard />} />
          
          {/* components */}
          <Route path='/access-health-care' element={<AccessHealthCareRecordsForm />} />
          <Route path='/matching-assesment' element={<MatchingAssesmentForm />} />
          <Route path='/cyp-forms' element={<CypForm />} />
          <Route path='/e-safety-contract' element={<ESafetyContractAdmission />} />
          <Route path='/essential-form' element={<EssentialInformationSheet />} />
          <Route path='/property-inventory' element={<PropertyInventoryAdmission />} />
          <Route path='/admission' element={<AdmissionForm />} />
          <Route path='/admission-confirmation' element={<AdmissionConfirmation />} />
          <Route path='/risk-assessment' element={<RiskAssessmentAdmission />} />
          <Route path='/personal-emergency' element={<PersonalEmergencyAdmission />} />
          <Route path='/home-rules-admission' element={<HouseRulesAdmission />} />
          <Route path='/e-safety-admission' element={<ESafetyContractAdmission />} />
          <Route path='/mobile-phone-admission' element={<MobilePhoneContractAdmission />} />
          <Route path='/anti-bully-admission' element={<AntiBullyingAdmission />} />
          <Route path='/ofsted-inspect-admission' element={<OfstedInspectContractAdmission />} />
          <Route path='/room-search-admission' element={<RoomSearchAgreeAdmission />} />
          <Route path='/medical-consent-admission' element={<MedicalConsentAdmission />} />
  

          <Route
            path='/validate-otp-login'
            element={
              <PrivateRoute>
                <ValidateOTPLogin />
              </PrivateRoute>
            }
          />
          <Route
            path='/home'
            element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
